var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 191.432,
    height: 29.4,
    viewBox: "0 0 191.432 29.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M35.64,21.794c.165-.055,5.376-1.77,6.011-1.9.585-.117.489.53.285,1.128a7.865,7.865,0,0,1-.382.9l.006,0-.014.029L57.3,16.5l-.048-.007.058-.02L45.415,14.534a4.03,4.03,0,0,0,.343-.733c.167-.479.218-1.037-.389-1.124-1.342-.2-8.024-1.266-8.024-1.266l-.007.027h0L32.994,28.961a8.735,8.735,0,0,1-5.544-8.628,14.487,14.487,0,0,1-3.963,5.24,19.174,19.174,0,0,1-12.043,4.577C3.589,30.151-1.578,25.3.437,17.038A17.7,17.7,0,0,1,17.995,3.583c4.473,0,10.078,2.218,11.018,6.625l-9.525,3.209a2.945,2.945,0,0,0-3.069-1.981c-3.346,0-5.89,2.87-6.648,5.975-.691,2.835.434,5.5,3.472,5.5a5.033,5.033,0,0,0,4.342-2.254H13.349l1.484-6.078H28.652a18.241,18.241,0,0,1,16.731-11c6.71,0,11.441,3.875,11.4,10.09l2.362-9.679H68.5L64.235,21.479h5.008l-2.017,8.263H52.861l2.317-9.49a17.972,17.972,0,0,1-16.278,9.9,16.412,16.412,0,0,1-5.112-.831L35.64,21.8Z",
    transform: "translate(0 -2.122)",
    fill: "#03aa4d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M155.429,11.759l1.8-7.377H139.984L133.7,30.13h9.424l2.2-9.015h6.864l1.632-6.693h-6.864l.648-2.665Z",
    transform: "translate(-65.232 -2.512)",
    fill: "#03aa4d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M181.444,3.1h15.742V6.845H191.3v22h-4.008v-22h-5.844V3.1m74.208.625-10.3,25.82-.43,1.083L244.5,29.54l-6.589-17.1-6.589,17.1-.417,1.088-.432-1.083-10.3-25.82-.251-.627h4.342l.112.291,6.511,16.685,6.591-17.207.429-1.116.425,1.116,6.6,17.207,6.511-16.685.115-.291h4.345Z",
    transform: "translate(-88.524 -1.228)",
    fill: "#be1e24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M352.253,3.059v27L333.634,10.522V28.348h-4.008V.731l.785.827,17.834,18.7V2.6h4.006Z",
    transform: "translate(-160.82 -0.731)",
    fill: "#be1e24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M221.66,7.167a9.588,9.588,0,1,0,9.445,9.587,9.517,9.517,0,0,0-9.445-9.587m13.45,9.587a13.45,13.45,0,1,1-13.45-13.4,13.427,13.427,0,0,1,13.45,13.4",
    transform: "translate(-101.583 -2.01)",
    fill: "#be1e24"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b51dd0c55d0d874a153f91a817b8dad4.svg";
export { ForwardRef as ReactComponent };